/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Alert } from 'reactstrap';
import { get, find, has } from 'lodash';

import { Button, FormHeader, FormButtonsWrapper, FormItem, Spinner, SmstIcon } from '@skunexus/component-catalog';
import { useWebsites, FIELD_PATH, WAREHOUSE_PATH } from './useWebsites';

import styles from './styles.module.css';

function WebsitesFields(props) {
    const { details, dictionaries, onChangeField, isLoading, formData } = props;
    const { websiteMapError, handleAddPair, handleRemovePair, handleChangeField } = useWebsites(props);

    if (!has(details, 'id'))
        return <Alert color="warning">Options for mapping will be displayed when editing the integration.</Alert>;

    if (isLoading)
        return (
            <div className="py-4">
                <Spinner />
            </div>
        );

    return (
        <div>
            <Row>
                <Col>
                    <FormHeader>Warehouse Website Map</FormHeader>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormItem
                        label="Default Warehouse"
                        name={WAREHOUSE_PATH}
                        type="dropdown"
                        value={get(formData, WAREHOUSE_PATH)}
                        options={get(dictionaries, 'warehouses', [])}
                        validate={{ required: { value: true } }}
                        onChange={(value) => onChangeField({ name: WAREHOUSE_PATH, value })}
                    />
                </Col>
            </Row>
            {get(formData, FIELD_PATH, []).map(({ warehouse_id = '', website_id = '', website_code = '' }, key) => (
                <Row className="mb-4">
                    <Col sm={6}>
                        <FormItem
                            label="Warehouse"
                            name={`${FIELD_PATH}[${key}].warehouse_id`}
                            type="dropdown"
                            value={warehouse_id}
                            options={get(dictionaries, 'warehouses', [])}
                            validate={{ required: { value: true } }}
                            onChange={(value) => handleChangeField(key, 'warehouse_id', value)}
                        />
                    </Col>
                    <Col sm={6}>
                        <div className={styles.websiteValueCol}>
                            <FormItem
                                label="Website"
                                name={`${FIELD_PATH}[${key}].website_id`}
                                type="dropdown"
                                value={website_id}
                                options={get(dictionaries, 'websites', [])}
                                validate={{ required: { value: true } }}
                                onChange={(value) => handleChangeField(key, 'website_id', value)}
                            />
                            <Button outline onlyIcon size="sm" icon="Trash3" onClick={() => handleRemovePair(key)} />
                        </div>
                        <FormItem
                            type="hidden"
                            name={`${FIELD_PATH}[${key}].website_code`}
                            value={
                                website_code ||
                                get(find(get(dictionaries, 'websites', []), ['value', website_id]), 'code', '')
                            }
                            validate={{ required: { value: true } }}
                            readOnly
                        />
                    </Col>
                </Row>
            ))}
            {websiteMapError && (
                <Row>
                    <Col className="mt-3">
                        <Alert color="danger">Each warehouse can only be paired with one website.</Alert>
                    </Col>
                </Row>
            )}
            <Row>
                <Col sm={5}>
                    <FormButtonsWrapper className="mt-0 mb-4">
                        <Button outline size="sm" icon="PlusCircle" onClick={handleAddPair}>
                            Add {get(formData, FIELD_PATH, []).length ? 'Another ' : ''}
                            Warehouse-Website Pair
                        </Button>
                    </FormButtonsWrapper>
                </Col>
            </Row>
        </div>
    );
}

WebsitesFields.propTypes = {
    details: PropTypes.object,
    formData: PropTypes.object,
    dictionaries: PropTypes.object,
    onChangeField: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
};
WebsitesFields.defaultProps = {
    details: {},
    formData: {},
    dictionaries: {},
    isLoading: false,
};

export default WebsitesFields;

/* eslint-enable camelcase */
